import { globalApp } from "./app";

import { EmployeeUtilizationPeriod } from "./models/EmployeeUtilizationPeriod";
import { PageContext } from "./page-context";
import { Navigation } from "./navigation";
import { AssignmentDemand } from "./models/AssignmentDemand";

export function showError(msg: string, empty = false) {
    var elem = '<span id="message" class="alert alert-danger" role="alert">' + "Error: " + msg + '<button type="button" class="btn-close error-msg-close" aria-label="Close"></button></span>'
    if (empty) {
        $(".main").empty();
    }
    $(".main").prepend(elem);
    $(".loader").hide();
    $(".error-msg-close").on("click", function () {
        $(this).closest(".alert").hide();
    })
}

export function fireBaseLog(eventName: string, eventData: any) {
    globalApp.app.firebase.logEvent(eventName, eventData);
}

/**
 * Show a modal with title and payload
 * @param {string} title 
 * @param {BaseView} payload 
 * @param {PageContext} context 
 * @returns {Promise<any>} returns a promise that resolves when the modal is closed. Undefined if the modal is closed without action. Value if updated data is available. Null if data has been deleted.
 */
export async function showModal<T extends { new(...args: any[]): any }>(title: string, payload: T | string, context: PageContext) {
    $(".modal-title").html(title);
    $(".loader").show();

    if (typeof payload === "function") {
        var view = new payload(context, ".modal-body");

        const modelBody = document.querySelector(".modal-body");
        if (modelBody) {
            modelBody.innerHTML = '';
            modelBody.appendChild(view);
        }

        var modal = $("#detailModal").modal("show");

        const closePromise = new Promise<void>((resolve, reject) => {
            modal.off().on("hide.bs.modal", () => resolve());
        });
        const resultPromise = view.getResult();

        const promises = [closePromise, resultPromise];
        return Promise.any(promises);
    } else if (typeof payload === "string") {
        $(".modal-body").html(payload.toString());
        var modal = $("#detailModal").modal("show");
        $(".loader").hide();
        const closePromise = new Promise<void>((resolve, reject) => {
            modal.off().on("hide.bs.modal", () => resolve());
        });
        return closePromise;
    }

}

/**
 * Close the modal
 * @returns {void}
 */
export function closeModal() {
    $("#detailModal").modal("hide");
}

/**
 * 
 * @param {string} title
 * @param {string} message
 * @param {string} icon
 * @returns {void}
 */
export function showToast(title: string, message: string, icon = '<i class="bi bi-info-circle"></i>', delay = 5000) {
    const elem = `<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-delay="${delay}">
    <div class="toast-header">
        ${icon}&nbsp;
      <strong class="me-auto">${title}</strong>
      <small class="text-muted">just now</small>
      <button type="button" class="btn-close" data-mdb-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">
        ${message}
    </div>
  </div>`;
    $(".toast-container").prepend(elem);
    $($(".toast")[0]).toast('show');
}

//add event handler for control + i key
document.addEventListener('keyup', async function (event) {
    if (event.ctrlKey && event.key === 'i') {
        const html = `<div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h4> Prompt</h4>
                    <textarea class="form-control" rows="5" id="prompt">Software development project with AWS Serverless and Python from April to May 2024. The goal is to develop a todo application for the company ABC.
                    </textarea>
                    <br>
                    <h4>Result</h4>
                    <div class="magicdemands">Execute to get result</div>
                    <br>
                    <button class="btn btn-primary" id="askGPTButton">Ask GPT</button>
                </div>
            </div>
        </div>`;
        showModal("🤖 Demand Assistant", html, globalApp.app.context);

        document.getElementById('askGPTButton')?.addEventListener('click', getMagicDemands);
    }
});

async function getMagicDemands() {
    const prompt = $(".modal-body #prompt").val();
    $(".loader").show();
    const result = await globalApp.context.store.getMagicDemands(prompt as string);
    console.log(result);
    let resultHtml = "<table class='table table-striped'><thead><tr><th>Role</th><th>Description</th></tr></thead><tbody>";
    result.map((r: AssignmentDemand) => {
        r.isNew = true;
        resultHtml += `<tr>
                <td>
                    <a href="${Navigation.buildNavigationUrl("/demands/detail", { data: r })}" target="_blank">${r.role}</a>
                </td>
                <td>${r.description}</td>
            </tr>`;
    });
    resultHtml += "</tbody></table>";
    $(".modal-body .magicdemands").html(resultHtml);
    $(".loader").hide();
}

export function getEmployeeUtilizationByWeek(utilizationArray: EmployeeUtilizationPeriod[], week: number, year: number): number {
    //get monday date for the week number
    let monday = new Date(year, 0, 1 + (week - 1) * 7);
    return getEmployeeUtilizationByDate(utilizationArray, monday);
}

export function getEmployeeUtilizationByDate(utilizationArray: EmployeeUtilizationPeriod[], date: Date): number {
    let hours = 40;
    utilizationArray.forEach((utilization) => {
        if (date >= utilization.startDate)
            hours = utilization.weeklyHours;
    });
    return hours;
}


export function buildRouteParamsString(params: any) {
    const urlparams = new URLSearchParams();

    for (var key in params) {
        if (key === "subpage") continue;
        if (typeof params[key] === "object") {
            urlparams.append(key, JSON.stringify(params[key]));
        } else {
            urlparams.append(key, params[key]);
        }
    }
    const strParams = urlparams.toString();
    return strParams;
}


/** Helper functions */

/**
 * get current week number of the year
 * monday is the first day of the week
 * ISO-8601 standard
 * @param {Date} tdt, default is today
 * @returns {number}
 */
export function getWeekNumber(date: Date = new Date()): number {
    let tdt: Date = new Date(date.valueOf());
    var dayn = (tdt.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    var firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - tdt.getTime()) / 604800000);
}

/**
 * Get the year of a date according to the ISO-8601 standard
 * @param {Date} date - The date from which to extract the year
 * @returns {number} - The year
 */
export function getWeekYear(date = new Date()) {
    let tdt = new Date(date.valueOf());
    var dayn = (tdt.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }
    return tdt.getFullYear();
}

/**
 * @param {number} weekNumber
 * @returns {string}
 */
export function buildCalendarWeekId(weekNumber: number) {
    return "cw_" + weekNumber + "_" + new Date().getFullYear();
}

/**
 * @returns {string}
 */
export function getCurrentCalendarWeekId() {
    return buildCalendarWeekId(getWeekNumber());
}

export function base64ToString(base64: string) {
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0)!);
    return new TextDecoder().decode(bytes);
}

export function strToBase64(str: string) {
    const bytes = new TextEncoder().encode(str);
    const binString = Array.from(bytes, (x) => String.fromCodePoint(x)).join("");
    return btoa(binString);
}

export function percentageToColor(perc: number, maxHue = 120, minHue = 0, saturation = 65, light = 65) {
    const hue = perc * (maxHue - minHue) + minHue;
    return `hsl(${hue}, ${saturation}%, ${light}%)`;
}

export function percentageToGray(perc: number, maxLight = 90, minLight = 50, saturation = 0, hue = 0) {
    const light = perc * (maxLight - minLight) + minLight;
    return `hsl(${hue}, ${saturation}%, ${light}%)`;
}

export function percentageToColorWithInvert(perc: number) {
    if (perc > 1) {
        perc = 1 - (perc - 1);
    }
    return percentageToColor(perc);
}




/**
 * Format date to locale, default dd/MM/yyyy
 * @param {string} val
 * @param {string} locale default is en-GB
 */
export function formatLocaleDateString(val: string | Date, locale = "en-GB"): string {
    if (!val) return '';
    const date = (val instanceof Date) ?
        val :
        parseStringToDate(val);
    if (!date)
        return '';
    return date.toLocaleDateString(locale);
}

/**
 * Check if input is a quarter year string, if yes, convert to date
 * @param {string} inputstr 
 * @returns {Date}
 */
export function parseStringToDate(inputstr: string | Date): Date | null {
    var retVal = null;
    if (inputstr == null) return null;
    if (inputstr instanceof Date) return inputstr;

    const regInputQuarter = /Q([1-4])[ \/]?(20[1-9][1-9])/i;
    const regInputHalfyear = /H([1-2])[ \/]?(20[1-9][1-9])/i;
    const regInputYear = /^(20[1-9][1-9])$/i;
    var match = null;

    if (typeof (inputstr) === "string") {
        if (match = regInputQuarter.exec(inputstr)) {
            const quarter: number = parseInt(match[1], 10);
            const year: number = parseInt(match[2], 10);
            const month: number = (quarter - 1) * 3;
            retVal = new Date(year, month, 1);
        } else if (match = regInputHalfyear.exec(inputstr)) {
            const halfyear: number = parseInt(match[1], 10);
            const year: number = parseInt(match[2], 10);
            const month = (halfyear - 1) * 6;
            retVal = new Date(year, month, 1);
        } else if (match = regInputYear.exec(inputstr)) {
            const year: number = parseInt(match[1], 10);
            retVal = new Date(year, 0, 1);
        } else {
            // try to parse as date
            if (!inputstr.endsWith("Z")) {
                try {
                    retVal = new Date(inputstr + 'T00:00:00.000Z');
                } catch (err) {

                }
            }

            if (!retVal) retVal = new Date(inputstr);
        }
    } else if (typeof (inputstr) === "number") {
        if (inputstr > 2000 && inputstr < 2099) {
            retVal = new Date(inputstr, 0, 1);
        } else {
            retVal = new Date(inputstr);
        }
    }

    return retVal;
}

/**
 * Parse Date with format dd/MM/yyyy if possible
 * @param {string} inputStr 
 * @returns {Date}
 */
export function parseDateWithFormatDayMonthYear(inputStr: string): Date {
    const parts = inputStr.split("/");
    const parsedDate = new Date(
        parseInt(parts[2], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[0], 10)
    );

    if (isValidDate(parsedDate)) return parsedDate;

    console.error(`cannot parse Date with format dd/MM/yyyy, input: ${inputStr}`);

    return new Date(inputStr);
}

/**
 * Check if a Date is valid
 * @param {Date} d 
 * @returns {boolean}
 */
export function isValidDate(d: Date | unknown): boolean {
    return d instanceof Date && !isNaN(d.getTime());
}

/**
 * Check if input is a string
 * @param {any} input 
 * @returns {boolean}
 */
export function isString(input: unknown): boolean {
    return typeof input === 'string';
}

/**
 * @param {string} name
 * @param {string} classAttr
 * @param {string} splitBy
 * @returns {string}
 */
export function createNameIconElementWith2Initials(name: string, classAttr: string, splitBy = " ") {
    if (!name)
        name = "";
    const iconTemplate = `<div class='${classAttr}' style='background-color:{color}; color:white'>{letters}</div>`;
    const colors = ["#0A324E", "#00A4B3", "#004772", "#8940AD"];

    // color by length of name
    const color = colors[name.length % colors.length];
    const initials = name.split(splitBy).map((n) => n[0]).join("").substring(0, 2).toUpperCase();

    return iconTemplate.replace("{color}", color).replace("{letters}", initials);
}

export function createEmployeePhotoElement(employeePhotoUrl: string, classAttr: string): string {
    return `<img class='${classAttr}' alt="icon" src="${employeePhotoUrl}" />`;
}

export function convertHtmlToNode(htmlString: string): ChildNode {
    const template = document.createElement("template");
    template.innerHTML = htmlString.trim();
    if (template.content.firstChild === null) throw new Error("HTML string is empty");
    return template.content.firstChild;
}

export function replaceAccentedCharacters(str: string) {
    return str.normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Checks if a string contains a given substring, case-insensitively.
 *
 * @param {string} str - The main string to search within.
 * @param {string} substr - The substring to search for.
 * @returns {boolean} - Returns true if the main string contains the substring, otherwise false.
 */
export function containsString(str: string, substr: string): boolean {
    if (str == null || substr == null) {
        return false;
    }
    str = str.trim().toLowerCase();
    substr = substr.trim().toLowerCase();
    return str.includes(substr);
}


/**
 * Sets the given date object to the end of the day (23:59:59.999).
 *
 * @param {Date} dateObj - The date object to be modified.
 * @returns {Date} The modified date object set to the end of the day.
 */
export function setToEndOfDay(dateObj: Date): Date {
    dateObj.setHours(23);
    dateObj.setMinutes(59);
    dateObj.setSeconds(59);
    dateObj.setMilliseconds(999);
    return dateObj;
}

/**
 * Checks the input values for the header filter function.
 *
 * @param {any} headerValue - The value from the header filter. Can be a single value or an array of values.
 * @param {any} rowValue - The value from the row to be checked against the header filter.
 * @returns {boolean} - Returns true if the header filter is empty or if the row value is not null/undefined, otherwise false.
 */
export function checkHeaderFilterFunctionInput(headerValue: any, rowValue: any) {
    if (headerValue.length === 0) return true;
    if (rowValue === null || rowValue === undefined) return false;
    return true;
}

/**
 * Calculate average of an array of numbers
 * @returns number
 */
export { };

declare global {
    interface Array<T> {
        avg(): number;
    }
}

Array.prototype.avg = function (): number {
    return this.reduce((a, b) => a + b, 0) / this.length;
}

/**
  * Update or Insert in local storage
  * @param {string} key
  * @param {object} value
  * @param {number} ttl time to live in milliseconds
  */
export function setLocalStorageWithExpiry(key: string, value: object, ttl: number) {
    const now = new Date();

    const item = {
        value: value,
        iat: now.getTime(),
        expiry: now.getTime() + ttl,
    };
    try {
        localStorage.setItem(key, JSON.stringify(item));
    } catch (e) {
        if (e instanceof DOMException) {
            switch (e.name) {
                case 'QuotaExceededError':
                case 'NS_ERROR_DOM_QUOTA_REACHED':
                    console.warn("Local storage quota exceeded. Clearing expired items and retrying.");
                    clearExpiredLocalStorageItems();
                    try {
                        localStorage.setItem(key, JSON.stringify(item));
                    } catch (e2) {
                        console.error("Still failing to set local storage after clearing expired items.", e2);
                    }
                    break;
                case 'SecurityError':
                    console.warn(`Could not cache item with key "${key}" due to browser security settings preventing storage.`);
                    break;
                default:
                    console.warn(`Could not cache item with key "${key}". Error: ${e.message}`);
                    break;
            }
        } else {
            console.warn(`An unknown error occurred while attempting to cache item with key "${key}".`);
        }
    }
}

/**
 *
 * @param {string} key
 * @param {object} defaultValue
 * @param {number | undefined} lastUpdatedTime
 * @param {boolean} canExtendBrowserCache
 * @returns {object} value
 */
export function getLocalStorageWithExpiry(key: string, defaultValue = null, lastUpdatedTime: number | undefined | null = null, canExtendBrowserCache = true) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
        return defaultValue;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (lastUpdatedTime != undefined && item.iat != undefined) {
        if (lastUpdatedTime >= item.iat) {
            localStorage.removeItem(key);
            return defaultValue;
        } else if (canExtendBrowserCache && now.getTime() >= item.expiry) {
            setLocalStorageWithExpiry(key, item.value, item.expiry - item.iat);
            return item.value;
        }
        else if (now.getTime() >= item.expiry) {
            localStorage.removeItem(key);
            return defaultValue;
        }
    } else if (now.getTime() >= item.expiry) {
        localStorage.removeItem(key);
        return defaultValue;
    }

    return item.value;
}

export function clearExpiredLocalStorageItems() {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
            getLocalStorageWithExpiry(key);
        }
    }
}

export function clearLocalStorage(entity: string) {
    if (entity) {
        localStorage.removeItem(entity);
        return;
    } else {
        localStorage.clear();
    }
}

